//Drawer action types
export const DrawerActionTypes = {
  SHOW_DRAWER: "SHOW_DRAWER",
};
